<div class="modal-top-bar">
    <h2>Create manual alert block ip</h2>
</div>
<div class="modal-content">
    <div [formGroup]="form" class="d-flex flex-row gap-2">
        <div class="d-flex flex-column w-50">
            <span class="form-field-header">IP or domain</span>
            <input formControlName="ip" type="text" placeholder="..." required />
            <span *ngIf="form.controls['ip'].errors != null" class="error-message">Required</span>
        </div>
        <div class="d-flex flex-column w-50">
            <span class="form-field-header">Type</span>
            <select formControlName="type" required>
                <ng-container *ngFor="let type of cyberAttackTypesEnum">
                    <option [value]="type">{{type}}</option>
                </ng-container>
            </select>
            <span *ngIf="form.controls['type'].errors != null" class="error-message">Required</span>
        </div>
    </div>
</div>
<div class="modal-bottom-bar">
    <button class="button outline mini wide" (click)="cancelClicked()">Close</button>
    <button class="button mini wide" [disabled]="!form.valid || working" (click)="saveClicked()">{{working? 'Saving...':
        'Save'}}</button>
</div>